import { AppSettings } from "@/AppSettings";
import { ConfigurationSourceDataMap, Metadata, Trial } from "@/api/dtos";
import { useMemo } from "react";
import { createItemValueConfiguration } from "./useItemValueConfiguration";

export const createItemValueConfigurations = (
    metadata?: Metadata, 
    trialConfigurationItemValues?: ConfigurationSourceDataMap['itemValues'], 
    configurationItemValues?: ConfigurationSourceDataMap['itemValues'], 
    trial?: Trial, 
    isGlobal?: boolean,
    configurationSourceDataId?: number, 
    studyEventOid?: string,
    caseReportFormOid?: string,
    caseReportFormVersionOid?: string,
    itemGroupName?: string,
    itemName?: string,
    baseRoute?: string
) => {
    const itemGroupKey = itemGroupName ?? AppSettings.metadata.itemGroupUngroupedKey;

    if (
        !caseReportFormOid ||
        !caseReportFormVersionOid ||
        !itemName ||
        !metadata || 
        (studyEventOid && !metadata.eventForms?.[studyEventOid]?.[caseReportFormOid]) ||
        !metadata.itemValues?.[caseReportFormOid]?.[caseReportFormVersionOid]?.[itemGroupKey]?.[itemName]
    ) {
        return undefined;
    }

    return (
        Object.keys(metadata.itemValues[caseReportFormOid][caseReportFormVersionOid][itemGroupKey][itemName]).map(itemValue => {
            return createItemValueConfiguration(
                metadata, 
                trialConfigurationItemValues, 
                configurationItemValues, 
                trial, 
                isGlobal,
                configurationSourceDataId, 
                studyEventOid,
                caseReportFormOid,
                caseReportFormVersionOid,
                itemGroupName,
                itemName,
                itemValue,
                baseRoute
            );
        }) as Array<NonNullable<ReturnType<typeof createItemValueConfiguration>>>
    )
    .filter(x => !!x)
    .sort((a, b) => a.itemValueMetadata.order! < b.itemValueMetadata?.order! ? -1 : 1)
}
const useItemValueConfigurations = (
    metadata?: Metadata, 
    trialConfiguration?: ConfigurationSourceDataMap, 
    configuration?: ConfigurationSourceDataMap, 
    trial?: Trial, 
    configurationSourceDataId?: number,
    studyEventOid?: string,
    caseReportFormOid?: string,
    caseReportFormVersionOid?: string,
    itemGroupName?: string,
    itemName?: string,
    baseRoute?: string
) => {
    return useMemo(
        () => {
            return createItemValueConfigurations(
                metadata,
                trialConfiguration?.itemValues,
                configuration?.itemValues,
                trial,
                configuration?.configuration?.isGlobal,
                configuration?.configuration?.id ?? configurationSourceDataId, 
                studyEventOid,
                caseReportFormOid,
                caseReportFormVersionOid,
                itemGroupName,
                itemName,
                baseRoute
            );
        }, 
        [
            metadata, 
            trialConfiguration?.itemValues, 
            configuration?.itemValues, 
            trial, 
            configurationSourceDataId, 
            studyEventOid, 
            caseReportFormOid, 
            caseReportFormVersionOid, 
            itemGroupName, 
            itemName,
            baseRoute
        ]
    ) 
};

export default useItemValueConfigurations;